import { DrawerHeader, IconButton } from '@one-thd/sui-atomic-components';
import { ArrowBack, Close } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { SubmitDeliveryAddressSuspendCart } from '../../../api/oms/edit-delivery-address';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { EditDeliveryAddressChangeForm } from './EditDeliveryAddressChangeForm';
import { EditDeliveryAddressDeliveryDetails } from './EditDeliveryAddressDeliveryDetails';
import { EditDeliveryAddressConfirmation } from './EditDeliveryAddressConfirmation';
import { EditDeliveryAddressSurvey } from './EditDeliveryAddressSurvey';
import { EditDeliveryAddressConfirmationBODFS } from './BodfsConfirmation/EditDeliveryAddressConfirmationBODFS';
import { getWindow } from '../../../utils/general';
import { useOrderContext, useFulfillmentGroupContext, } from '../../../hooks/useContexts';
import { extractAddressFromFulfillmentGroup } from '../../../utils/order-details/OrderDetailsUtils';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { getFlowTypeValue } from '../util/OutOfStock';
import { getCookieValue } from '../../../utils/cookie-helper';
import { mapLineIds, goBackToChangeForm, goBackToDeliveryDetails, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
export var EditDeliveryAddressDrawerContent = function (_a) {
    var _b, _c;
    var setOpen = _a.setOpen, setShowDrawerError = _a.setShowDrawerError, isBopisOutOfStock = _a.isBopisOutOfStock, isOuterClick = _a.isOuterClick, setIsOuterClick = _a.setIsOuterClick;
    var _d = useFulfillmentGroupContext(), fulfillmentGroup = _d.fulfillmentGroup, fulfillmentType = _d.fulfillmentType;
    var _e = useOrderContext(), currentDrawer = _e.currentDrawer, setCurrentDrawer = _e.setCurrentDrawer, orderDetailsData = _e.orderDetailsData, orderId = _e.orderId, setDeliveryAddresses = _e.setDeliveryAddresses;
    var _f = useState(true), isChangeForm = _f[0], setIsChangeForm = _f[1];
    var _g = useState(false), isDeliveryDetails = _g[0], setIsDeliveryDetails = _g[1];
    var _h = useState(false), isConfirmation = _h[0], setIsConfirmation = _h[1];
    var _j = useState(false), isSurvey = _j[0], setIsSurvey = _j[1];
    var _k = useState(false), enteredEditFlow = _k[0], setEnteredEditFlow = _k[1];
    var _l = useState(Boolean(FeatureSwitches.enableEditDeliveryAddressAppify)), isAddressList = _l[0], setIsAddressList = _l[1];
    // Stores info for re-load of OD page in session storage to determine what (if any) Alerts to render
    var _m = useState(), editDeliveryAddressAlert = _m[0], setEditDeliveryAddressAlert = _m[1];
    var _o = useState(), suspendCartData = _o[0], setSuspendCartData = _o[1];
    var _p = useState(false), isAddressChangeConfirmed = _p[0], setIsAddressChangeConfirmed = _p[1];
    var _q = useState(), updatedAddressData = _q[0], setUpdatedAddressData = _q[1];
    var _r = useState({}), newDeliveryAddressDetails = _r[0], setNewDeliveryAddressDetails = _r[1];
    // Change Form values (stored here as any change made needs to be retained while in flow)
    var _s = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentType), firstName = _s.firstName, lastName = _s.lastName, addressLine1 = _s.addressLine1, addressLine2 = _s.addressLine2, zipCode = _s.zipCode, city = _s.city, state = _s.state, phoneNumber = _s.phoneNumber, country = _s.country;
    var _t = useState(''), firstNameValue = _t[0], setFirstName = _t[1];
    var _u = useState(''), lastNameValue = _u[0], setLastName = _u[1];
    var _v = useState(''), streetAddressValue = _v[0], setStreetAddress = _v[1];
    var _w = useState(null), addressLineTwoValue = _w[0], setAddressLineTwo = _w[1];
    var _x = useState(''), zipCodeValue = _x[0], setZipCode = _x[1];
    var _y = useState(''), cityStateValue = _y[0], setCityState = _y[1];
    var _z = useState(''), phoneNumberValue = _z[0], setPhoneNumber = _z[1];
    var _0 = useState(false), isDefaultValue = _0[0], setIsDefault = _0[1];
    var _1 = useState(false), isLoading = _1[0], setIsLoading = _1[1];
    var _2 = useState(false), isExcludedAddress = _2[0], setIsExcludedAddress = _2[1];
    var _3 = useState(true), isValidated = _3[0], setIsValidated = _3[1];
    var _4 = useState({
        value: false,
        et: '',
    }), submitCreateForm = _4[0], setSubmitCreateForm = _4[1];
    var flowType = getFlowTypeValue(currentDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var deliveryAddressCreateCartRequestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        firstName: firstNameValue,
        lastName: lastNameValue,
        phoneNumber: phoneNumberValue,
        emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
        fulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
        storeId: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentStore) || '',
        lineIds: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            ? mapLineIds(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            : [],
        newDeliveryAddress: {
            addressLine1: streetAddressValue || '',
            addressLine2: addressLineTwoValue || null,
            city: cityStateValue.split(',')[0],
            state: (_c = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _c === void 0 ? void 0 : _c.trim(),
            zipCode: zipCodeValue,
            country: country,
        },
        forterToken: getCookieValue('forterToken') || '',
        net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
        et: (submitCreateForm === null || submitCreateForm === void 0 ? void 0 : submitCreateForm.et) || '',
        flowType: flowType,
    };
    var setChangeFormValues = function () {
        if (!currentDrawer) {
            setFirstName(firstName);
            setLastName(lastName);
            setStreetAddress(addressLine1);
            setAddressLineTwo(addressLine2);
            setZipCode(zipCode);
            setCityState("".concat(city, ", ").concat(state));
        }
        setPhoneNumber(phoneNumber);
    };
    var suspendCartCheck = function () {
        if (suspendCartData && !isAddressChangeConfirmed) {
            SubmitDeliveryAddressSuspendCart(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    // Handles all logic associated with closing drawer
    // Should always be invoked instead of directly invoking setOpen(false)
    var closeDrawer = function () {
        var _a, _b;
        // Reset outer click
        setIsOuterClick(false);
        if (currentDrawer) {
            setCurrentDrawer('');
        }
        setOpen(false);
        suspendCartCheck();
        setIsConfirmation(false);
        setIsSurvey(false);
        setDeliveryAddresses([]);
        if (isAddressChangeConfirmed) {
            setIsAddressChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
        else {
            setChangeFormValues();
        }
    };
    var goBack = function () {
        if (isChangeForm) {
            // Back to the address list when feature is enabled
            if (FeatureSwitches.enableEditDeliveryAddressAppify && !isAddressList) {
                setIsAddressList(true);
                return;
            }
            // Back to review your options
            if (currentDrawer) {
                setCurrentDrawer('');
                setDeliveryAddresses([]);
                return;
            }
        }
        if (isConfirmation) {
            goBackToDeliveryDetails(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        if (isDeliveryDetails) {
            goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        closeDrawer();
    };
    useEffect(function () {
        var _a;
        if (editDeliveryAddressAlert) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editDeliveryAddressAlert', JSON.stringify(editDeliveryAddressAlert));
        }
    }, [editDeliveryAddressAlert]);
    useEffect(function () {
        var _a;
        if (currentDrawer === 'STH_DELIVERY_OPTION') {
            TrackBopisOosrAnalytics('out of stock review your options: switch to delivery', 'overlay');
        }
        setChangeFormValues();
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        var _a;
        if (updatedAddressData) {
            setSuspendCartData({
                cartId: updatedAddressData.ordersInfo.data.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
                flowType: flowType,
                fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
                    undefined,
            });
        }
    }, [updatedAddressData]);
    useEffect(function () {
        if (isOuterClick) {
            closeDrawer();
        }
    }, [isOuterClick]);
    var handleDrawerHeader = function () {
        if (isConfirmation) {
            return 'Confirm Delivery Address';
        }
        if (isDeliveryDetails) {
            return 'Delivery Details';
        }
        if (isBopisOutOfStock) {
            return isAddressList
                ? 'Choose Delivery Address'
                : 'Add New Delivery Address';
        }
        if (isChangeForm && FeatureSwitches.enableEditDeliveryAddressAppify) {
            return isAddressList
                ? 'Choose New Delivery Address'
                : 'Add New Delivery Address';
        }
        return 'Edit Delivery Address';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { title: handleDrawerHeader(), endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: function () { return closeDrawer(); }, icon: Close }), startAdornment: (!isChangeForm ||
                currentDrawer ||
                (FeatureSwitches.enableEditDeliveryAddressAppify &&
                    !isAddressList)) &&
                !isSurvey && (React.createElement(IconButton, { "aria-label": "go-back", onClick: function () { return goBack(); }, icon: ArrowBack })) }),
        isChangeForm && (React.createElement(EditDeliveryAddressChangeForm, { firstNameValue: firstNameValue, setFirstName: setFirstName, lastNameValue: lastNameValue, setLastName: setLastName, streetAddressValue: streetAddressValue, setStreetAddress: setStreetAddress, addressLineTwoValue: addressLineTwoValue, setAddressLineTwo: setAddressLineTwo, zipCodeValue: zipCodeValue, setZipCode: setZipCode, cityStateValue: cityStateValue, setCityState: setCityState, phoneNumberValue: phoneNumberValue, setPhoneNumber: setPhoneNumber, previousCountry: country || '', closeDrawer: closeDrawer, setIsChangeForm: setIsChangeForm, enteredEditFlow: enteredEditFlow, setEnteredEditFlow: setEnteredEditFlow, setShowDrawerError: setShowDrawerError, setIsDeliveryDetails: setIsDeliveryDetails, setUpdatedAddressData: setUpdatedAddressData, setNewDeliveryAddressDetails: setNewDeliveryAddressDetails, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, setIsAddressList: setIsAddressList, isAddressList: isAddressList, isDefaultValue: isDefaultValue, setIsDefault: setIsDefault, setOpen: setOpen, setIsLoading: setIsLoading, isLoading: isLoading, isExcludedAddress: isExcludedAddress, setIsExcludedAddress: setIsExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, submitCreateForm: submitCreateForm, setSubmitCreateForm: setSubmitCreateForm })),
        isDeliveryDetails && (React.createElement(EditDeliveryAddressDeliveryDetails, { updatedAddressData: updatedAddressData, setUpdatedAddressData: setUpdatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsDeliveryDetails: setIsDeliveryDetails, isDeliveryDetails: isDeliveryDetails, suspendCartCheck: suspendCartCheck, setIsLoading: setIsLoading, setShowDrawerError: setShowDrawerError, setIsExcludedAddress: setIsExcludedAddress, setIsValidated: setIsValidated, closeDrawer: closeDrawer, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, traceId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData })),
        isConfirmation &&
            updatedAddressData &&
            (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS ? (React.createElement(EditDeliveryAddressConfirmationBODFS, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, setShowDrawerError: setShowDrawerError, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed, setIsDeliveryDetails: setIsDeliveryDetails, setSubmitCreateForm: setSubmitCreateForm })) : (React.createElement(EditDeliveryAddressConfirmation, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, isDeliveryDetails: isDeliveryDetails, setShowDrawerError: setShowDrawerError, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed }))),
        isSurvey && (React.createElement(EditDeliveryAddressSurvey, { closeDrawer: closeDrawer, newOrderId: editDeliveryAddressAlert === null || editDeliveryAddressAlert === void 0 ? void 0 : editDeliveryAddressAlert.newOrderId, isBopisOutOfStock: isBopisOutOfStock }))));
};
